import { render, staticRenderFns } from "./HomeAccountDetails.vue?vue&type=template&id=b83e72e0"
import script from "./HomeAccountDetails.vue?vue&type=script&lang=js"
export * from "./HomeAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports